export const iconFontAwesomeGendersTransgender = (
	<i className="fa-solid fa-transgender"></i>
);
